/**
 * JS data filter for extras
 * Must be minified. Use: https://skalman.github.io/UglifyJS-online/
 * @type {{$, g}}
 */
var site = site || {};
var datafilter = (function ($) {
	"use strict";
	var $dataFilter,
		init = function () {
			$dataFilter = $('div.filterControls');
			if ($dataFilter.length > 0) {
				var options = !Object.is(site.datafilter, undefined) && !Object.is(site.datafilter.options, undefined)
					? site.datafilter.options : null;
				datafilter.main.init(options);
				$('body').addClass('filterReady');
			}
		};
	$(document).ready(init);
	return {
		$: $,
		g: function () {
			return $dataFilter.closest('.category');
		}
	};
})(jQuery);

datafilter.main = (function (parent) {
	"use strict";
	var $ = parent.$,
		$form,
		$input,
		$select,
		$link,
		$list,
		options,
		init = function (opt) {
			options = opt;
			$list = parent.g().find('.item');
			jQuery.expr[':'].startsWith = function (a, i, m) {
				//noinspection JSConstructorReturnsPrimitive
				var t = $(a).text().replace(/^\s*/, '').substring(0, 1);
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			jQuery.expr[':'].containsIC = function (a, i, m) {
				var t = $(a).text();
				var searchTerm = m[3].split(" ");
				var $isMatch = true;
				for (var i = 0; i < searchTerm.length; i++) {
					if ((t || "").toUpperCase().indexOf(searchTerm[i].toUpperCase()) === -1) {
						$isMatch = false;
						break;
					}
				}
				return $isMatch;
			};
			initSearch();
			initMaxHeight();
			initToggleOpen();
		},
		initSearch = function () {
			$form = parent.g().find('form');
			$form.on('submit', function(e) {
				e.preventDefault();
			});
			$input = $form.find('input').keyup(function (e) {
				//if (e.which == 13) { // Enter
				var t = this;
				doSearch.call(t);
				updateQuery(($input.val()));
				//}
			});
			$select = $form.find('select').change(doSearch);
			$link = $form.find('a').click(doSearch);

			var hash = location.hash.slice(1);
			var selectedHash = hash.length > 0 ? hash : '';
			if (hash) {
				if ($link.length > 0) {
					$form.find('.' + selectedHash).trigger('click');
				}
				else if ($select.length > 0) {
					$select.val(selectedHash).trigger('change')
				}
			}
			if ($input.length > 0 && getOption('addQueryToInput')) {
				var urlParams = new URLSearchParams(window.location.search),
					filterQuery = urlParams.get('f');

				if (filterQuery) {
					$input.val(decodeURI(filterQuery)).trigger('keyup');
				}
			}
		},

		initMaxHeight = function() {
			var selector = $('.item', '.filterControls + .items');
			$(window).load(function() {
				setHeight(selector);
			});
			$(window).resize(function () {
				setHeight(selector);
			});
		},

		setHeight = function (selector) {
			$(selector).each(function () {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		},

		initToggleOpen = function() {
			var $toggleOpen = $('.toggleOpen'),
				$toggleBar = $('.toggleBar');
			if (!$toggleOpen.length) {
				return false;
			}

			$toggleOpen.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				$(this).closest('.item').toggleClass('open');
			});

			if ($toggleBar.length) {
				$toggleBar.on('click', function (e) {
					if (!$(e.target).is('a') && !$(e.target).parents('a').length) {
						$(this).find('.toggleOpen').click();
					}
				});
			}
		},

		doSearch = function (e) {
			if (e) {
				e.preventDefault();
			}
			var $this = $(this),
				$res = $list,
				t = this.tagName;

			var selectValue = $select.val();
			if (selectValue) {
				$res = $res.filter('.' + selectValue);
			}
			var searchValue = $input.val();
			if (searchValue) {
				$res = $res.find(':containsIC("' + searchValue + '")').parent();
			}

			//Select
			if (t === 'SELECT') {
				$link.removeClass('selected');
				setHash(selectValue);
			}

			//Searching
			else if (t === 'INPUT') {
				$link.removeClass('selected');
			}

			//Clicking
			else {
				updateQuery();

				if ($this.hasClass('all')) {
					$link.removeClass('selected');
					$select.prop('selectedIndex', 0);
				}
				if ($this.hasClass('selected') && !$this.hasClass('all')) {
					$link.removeClass('selected');
				}
				else {
					$link.removeClass('selected');
					$this.addClass('selected');
				}

				var linkHref = $link.filter('.selected').attr('href');
				linkHref = linkHref ? linkHref.replace('#', '') : '';

				if ($this.parent().hasClass('parentsFilter') || !linkHref) {
					$('#childrenFilter').children('a').each(function () {
						// Check for data-parent attribute
						if ($(this).attr('data-parent') === $this.attr('id') && linkHref) {
							$(this).removeClass('hide');
						}
						else {
							$(this).addClass('hide');
						}
					});
				}
				else if ($this.parent().hasClass('childrenFilter')) {
					// Get data-parent attr of children to add selected class to parent filter
					const dataParent = $this.attr('data-parent')
					$('#'+dataParent).addClass('selected');

					// Remove hide from all children
					$('#childrenFilter').children('a').each(function () {
						if ($(this).attr('data-parent') === dataParent) {
							$(this).removeClass('hide');
						}
					});
				}

				if (linkHref) {
					linkHref = linkHref.replace('#', '');

					if ($this.parent().hasClass('linksFilter') || $this.parent().hasClass('parentsFilter') || $this.parent().hasClass('childrenFilter')) {
						$res = $res.filter('.' + linkHref);
					}
				}
				else if ($this.data('char') && $this.data('char').length > 0) {
					$select.prop('selectedIndex', 0);
					if ($this.hasClass('selected')) {
						var selectedAlpha = $this.data('char');
						$res = $res.find('.title:startsWith("' + selectedAlpha + '")').closest('.item');
					}
					else {
						linkHref = '';
					}
				}
				else if ($this.data('chars') && $this.data('chars').length > 0) {
					$select.prop('selectedIndex', 0);
					if ($this.hasClass('selected')) {
						var chars = $this.data('chars');
						$res = $res.filter(function() {
							return chars.indexOf($('.title', $(this)).text().trim().charAt(0).toUpperCase()) !== -1;
						}).closest('.item');
					}
					else {
						linkHref = '';
					}
				}

				setHash(linkHref);
			}

			result($res);
		},
		result = function ($filtered) {
			if ($filtered) {
				$list.addClass('hide');
				$filtered.removeClass('hide');
			}
			else {
				$list.removeClass('hide');
			}

			if ($filtered.length === $list.length) {
				$('body').removeClass('isFiltering');
			}
			else {
				$('body').addClass('isFiltering');
			}

			checkGroups();
			$(window).trigger('resize');
		},

		setHash = function(hash) {
			var scrollTop = $(window).scrollTop() ;
			location.hash = hash;
			window.scrollTo(0, scrollTop);

			if ((site.datafilter !== undefined) && typeof site.datafilter.setHash === 'function') {
				site.datafilter.setHash(parent.g().attr('class'), hash);
			}
		},

		updateQuery = function(query) {
			if (!getOption('updateQueryOnType')) {
				return false;
			}
			if (!query) {
				$input.val('');
			}
			if (history.pushState) {
				var newurl = window.location.protocol + "//"
					+ window.location.host + window.location.pathname;
				if (query && query.length > 0) {
					newurl += '?f=' + query;
				}
				window.history.pushState({path:newurl},'',newurl);
			}
		},

		checkGroups = function() {
			if (!getOption('checkGroups')) {
				return false;
			}

			$('.filterGroup', parent.g()).each(function() {
				var $group = $(this);
				if ($('.item', $group).length === $('.item.hide', $group).length) {
					$group.addClass('hide');
				}
				else {
					$group.removeClass('hide');
				}
			});
		},

		getOption = function(key, defaultValue) {
			var ret = defaultValue !== undefined ? defaultValue : null;
			if (options && key in options) {
				ret = options[key];
			}
			return ret;
		};
	return {
		init: init
	};
})(datafilter);

if (!Object.is) {
	Object.is = function(x, y) {
		// SameValue algorithm
		if (x === y) { // Steps 1-5, 7-10
			// Steps 6.b-6.e: +0 != -0
			return x !== 0 || 1 / x === 1 / y;
		} else {
			// Step 6.a: NaN == NaN
			return x !== x && y !== y;
		}
	};
}

(function (w) {
	w.URLSearchParams = w.URLSearchParams || function (searchString) {
		var self = this;
		self.searchString = searchString;
		self.get = function (name) {
			var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
			if (results == null) {
				return null;
			}
			else {
				return decodeURI(results[1]) || 0;
			}
		};
	}
})(window)
